import { dateFnsFormat } from '@/helpers/dateFns';

export default {
  methods: {},
  filters: {
    ...dateFnsFormat,
  },
};
